import { useState } from 'react'
import { Box, Grid2, IconButton, Stack, Typography } from '@mui/material'
import CustomDivider from '../../../shared/utils/CustomDivider'
import { NormalContainerWithHeader } from '../../../shared/components/student/NormalComponent'
import { Field } from 'formik'
import * as Yup from 'yup'
import { useAllAdminState, useAllAdminCountry } from '../../../assets/api/useAdminApi'
import { IdAutoCompleteField } from '../../../shared/components/formfields/IdAutoCompleteField'
import StateForm from './StateForm'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToaster } from '../../../shared/utils/ToasterProvider'
import EditIcon from '@mui/icons-material/Edit';
import ToggleSwitch from '../../../shared/utils/CustomToggle';
import TableFilterTemplate from '../../../shared/utils/TableFilterTemplate'
import api from '../../../assets/nodeApi/axiosInstance'

const State = () => {
  const [selectedState, setSelectedState] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const { showToaster } = useToaster();
  const queryClient = useQueryClient();
  const [filters, setFilters] = useState({ country_id: 99 });
  const { data: stateList, isLoading: stateLoading } = useAllAdminState(filters);
  const { data: countryList, isLoading: countryLoading } = useAllAdminCountry();
  const countryOption = countryList?.data?.map((item) => ({
    id: item?.id,
    label: item?.country_name,
    value: item?.country_name,
  }));
  const validationSchema = Yup.object().shape({
    country_id: Yup.string().required("Country is required"),
    status: Yup.string().required("Status is required"),
  });
  const handleFormSuccess = () => {
    setIsEditing(false);
    setSelectedState(null);
  };

  // const mutationUpdate = useMutation({
  //   mutationFn: (formData) => api.put(`region/update-status`, formData),
  // });

  const mutationUpdate = useMutation({
    mutationFn: ({ data, id }) =>
      api.put(`region/update-status/${id}`, data),
  });
  const handleToggleChange = (row) => {
    const obj = {
      "table": "states",

      "status": row?.status == 1 ? false : true
    }
    mutationUpdate.mutate({ data: obj, id: row?.id }, {
      onSuccess: (response) => {
        if (response?.data?.message) {
          showToaster("State updated successfully!", '', 'success');
          queryClient.invalidateQueries({ queryKey: ["all-states-list"] });

        } else {
          showToaster('Something went wrong!', '', 'error');
        }
      },
      onError: (error) => {
        showToaster(error?.data?.error || "Failed to update State", '', 'error');
      }
    });
  };
  const stateColumns = [
    {
      field: "sr_no",
      headerName: "Sr No",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

    },
    {
      field: "state_name",
      headerName: "State Name",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },

    {
      field: "country_name",
      headerName: "Country Name",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => <Typography variant="body2">{params.value === 1 ? "Active" : "Inactive"}</Typography>,
    },
    {
      field: "actionsEdit",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <IconButton
            onClick={() => {
              setSelectedState(params?.row)
              setIsEditing(true);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            size="small"
          >
            <EditIcon color="text.primary" />
          </IconButton>
        </Stack>
      ),
    },
    {
      field: "actionsDelete",
      headerName: "Change Status",
      flex: 1,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <ToggleSwitch checked={params?.row?.status} onCheck={() => handleToggleChange(params?.row)} />
        </Stack>
      ),
    }
  ];

  return (
    <Box>
      <CustomDivider />
      <NormalContainerWithHeader headerText={isEditing ? "Edit State" : "Add State"}>
        <StateForm
          initialState={selectedState}
          isEditing={isEditing}
          onSuccess={handleFormSuccess}
        />
      </NormalContainerWithHeader>
      <CustomDivider />

      <TableFilterTemplate
        title="State List"
        columns={stateColumns}
        rowsData={stateList?.data || []}
        isLoading={stateLoading}
        filterInitialValues={filters}
        filterReset={() => setFilters({})}
        onApplyFilters={(f) => setFilters(f)}
        renderFilterFields={() => (
          <>

            <Grid2 children size={12}>
              <Field
                name="country_id"
                component={IdAutoCompleteField}
                options={countryOption}
                label="Select Country"
                isRequired={true}

                isLoading={countryLoading}
              />
            </Grid2>
            <Grid2 children size={12}>
              <Field
                name="status"
                component={IdAutoCompleteField}
                options={[
                  { id: 1, label: "Active", value: "Active" },
                  { id: 0, label: "Inactive", value: "Inactive" }
                ]}
                label="Status"
                isRequired={true}
              />
            </Grid2>
          </>
        )}
      />




    </Box>
  )
}

export default State